import {
  type DashboardActions,
  InternalDashboardActions,
} from '@store/reducers/dashboard/actions'
import { call, put } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'

export function* leaveTeam({
  payload: { workspaceId },
}: ReturnType<typeof DashboardActions.members.leaveTeam>) {
  yield call(NestClient.membership.leave, workspaceId)
  yield call(sendGtmEvent, GtmTriggerName.TEAM_LEAVE)
  yield put(InternalDashboardActions.delete({ workspaceId }))
}
